module.exports = __webpack_public_path__ + "img/region_new_england.a3ff5eb9.svg";